// Import the functions you need from the SDKs you need
// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDWd3ybHoX4DlHXaFs3mpao0SpYVPwldNs",
    authDomain: "beachtenis-4a959.firebaseapp.com",
    projectId: "beachtenis-4a959",
    storageBucket: "beachtenis-4a959.appspot.com",
    messagingSenderId: "449588777692",
    appId: "1:449588777692:web:acd9128e72aae8e7e59a19"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc };
